// Backend-backed "email alerts by staff type" settings.
//
// Unlike departmentFilter.js (where no saved rows means "show everything"),
// here no saved rows means "no email alerts enabled for anyone" — this is a
// new, additive notification channel and must default to off, not on, so we
// never start emailing people an admin never opted in.

import axios from "axios";

const API_URL = "https://topschool.prisms.in/rest/index.php/user_list.json?";

// Resolves to { configured: boolean }. Fails closed (configured: false) on
// any network/parsing error, since we should never let an admin enable email
// alerts while unsure whether mail actually works.
export function checkMailConfig() {
  return axios
    .post(API_URL, { fun_name: "CheckMailConfig" }, { timeout: 20000 })
    .then(function (res) {
      return { configured: !!(res.data && res.data.configured) };
    })
    .catch(function (err) {
      console.error("[emailAlertSettings] CheckMailConfig failed:", err);
      return { configured: false };
    });
}

// Resolves to the array of staff `type` values that currently have email
// alerts enabled for this school. Empty array (not null) is the safe default
// on any failure or when nothing has been configured yet.
export function fetchEnabledEmailAlertTypes(sid) {
  return axios
    .post(API_URL, { fun_name: "GetEmailAlertTypes", sid: sid }, { timeout: 20000 })
    .then(function (res) {
      return res.data && Array.isArray(res.data.types) ? res.data.types : [];
    })
    .catch(function (err) {
      console.error("[emailAlertSettings] GetEmailAlertTypes failed:", err);
      return [];
    });
}

// Resolves to true/false depending on whether the save succeeded.
export function saveEnabledEmailAlertTypes(sid, list) {
  return axios
    .post(API_URL, { fun_name: "SaveEmailAlertTypes", sid: sid, types: JSON.stringify(list) }, { timeout: 20000 })
    .then(function (res) {
      return !!(res.data && res.data.success);
    })
    .catch(function (err) {
      console.error("[emailAlertSettings] SaveEmailAlertTypes failed:", err);
      return false;
    });
}

// Resolves to an array of recent failure records (shape TBD by backend, but
// treated defensively here — anything not a proper array becomes []).
export function fetchEmailAlertFailures(sid) {
  return axios
    .post(API_URL, { fun_name: "GetEmailAlertFailures", sid: sid }, { timeout: 20000 })
    .then(function (res) {
      return res.data && Array.isArray(res.data.failures) ? res.data.failures : [];
    })
    .catch(function (err) {
      console.error("[emailAlertSettings] GetEmailAlertFailures failed:", err);
      return [];
    });
}
